export default class WorkplaceService {

    apiPath = '/umbraco/api/workplace/';

    /**
     * Gets city name by zipcode
     * @param {string} zipCode 
     * @return {Promise<Array<Object>>}
     */
    query(searchText) {

        const url = new URL(`${this.apiPath}get`, location.origin);

        url.search = new URLSearchParams({ searchText }).toString();

        return fetch(url, {
            method: 'GET'
        })
            .then(response => {
                return response.json();
            }).then(data => {
                return data;
            });
    }
}